import styles from './index.module.scss'

export function ImageSkeleton() {
  return <div className={styles.image} />
}
